import type { ReactNode } from 'react'

type AuthRegisterViewProps = {
  customerAreaLabel: string
  title: string
  subtitle: string
  authCard: ReactNode
  previewLabel: string
  sidebarTitle: string
  sidebarDescription: string
  stepOfLabel: string
  currentStepLabel: string
  currentStepDescription: string
  accountSupportLabel: string
  trustHint: string
  trustItems: string[]
}

export const AuthRegisterView = ({
  customerAreaLabel,
  title,
  subtitle,
  authCard,
  previewLabel,
  sidebarTitle,
  sidebarDescription,
  stepOfLabel,
  currentStepLabel,
  currentStepDescription,
  accountSupportLabel,
  trustHint,
  trustItems,
}: AuthRegisterViewProps) => (
  <div className="grid gap-8 lg:grid-cols-12 lg:gap-10">
    <div className="lg:col-span-7">
      <div className="w-full max-w-[640px] space-y-6">
        <header className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-(--color-status-info)">
            {customerAreaLabel}
          </p>
          <h1 className="max-w-[20ch] text-balance text-3xl font-semibold tracking-tight text-(--color-text-primary)">
            {title}
          </h1>
          <p className="max-w-[62ch] text-sm leading-relaxed text-(--color-text-secondary)">
            {subtitle}
          </p>
        </header>
        {authCard}
      </div>
    </div>

    <aside className="lg:col-span-5">
      <div className="space-y-5 rounded-2xl bg-[color-mix(in_srgb,var(--color-bg-card)_74%,var(--color-bg-page-secondary))] p-5">
        <div className="space-y-1.5">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-(--color-text-muted)">
            {previewLabel}
          </p>
          <h2 className="text-lg font-semibold text-(--color-text-primary)">{sidebarTitle}</h2>
          <p className="text-sm leading-relaxed text-(--color-text-secondary)">{sidebarDescription}</p>
        </div>
        <div className="space-y-2 border-t border-[color-mix(in_srgb,var(--color-border-default)_80%,transparent)] pt-4">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-(--color-text-muted)">
            {stepOfLabel}
          </p>
          <p className="text-sm font-semibold text-(--color-text-primary)">{currentStepLabel}</p>
          <p className="text-xs leading-relaxed text-(--color-text-secondary)">{currentStepDescription}</p>
        </div>
        <div className="space-y-2 border-t border-[color-mix(in_srgb,var(--color-border-default)_80%,transparent)] pt-4">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-(--color-text-muted)">
            {accountSupportLabel}
          </p>
          <p className="text-xs leading-relaxed text-(--color-text-secondary)">{trustHint}</p>
          <ul className="flex flex-wrap gap-2 text-[11px]">
            {trustItems.map((item) => (
              <li
                key={item}
                className="rounded-full bg-(--color-bg-card) px-2.5 py-1 font-medium text-(--color-text-secondary)"
              >
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </aside>
  </div>
)
